import { Component } from '@angular/core';
import * as PIXI from "pixi.js";
import {
  AfterViewInit,
  ElementRef,
  inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { Store } from "@ngrx/store";
import {HeaderBarComponent} from "../../../../interface-components/header-bar/header-bar.component";
import {ProfileComponent} from "../../../../interface-components/profile/profile.component";
import {NewHolderComponent} from "../../../../interface-components/new-holder/new-holder.component";
import {BontrollerComponent} from "../../../../interface-components/bontroller/bontroller.component";
import {ActivatedRoute, Router, RouterOutlet} from "@angular/router";
import {NgClass} from "@angular/common";
import {ContextMenuComponent} from "../../../../interface-components/context-menu/context-menu.component";
import {ThreeService} from "../../../rendering/threejs/three.service";
import {ThreeInputService} from "../../../inputs/input-middlewares/three-input.middleware";
import {InputService} from "../../../inputs/services/input.service";
import {MapInputService} from "../../../inputs/input-middlewares/map-input.middleware";
import {SurfaceService} from "../../../surface/surface.service";
import {DebrisService} from "../../../ambients/debris-service";
import {EventSenderService} from "../../event-sender.service";
import {EventsWebsocketService} from "../../../../services/entities/events-websocket.service";
import {ChatsService} from "../../../../services/chats.service";
import {ReactionsService} from "../../../../services/reactions.service";
import {PushNotificationService} from "../../../../services/notifications/push-notification-service.service";
import {PwaInstallService} from "../../../../services/notifications/pwa-install.service";
import * as interfaceSelectors from "../../../../state/interface/interface.selector"
import {cameraActions} from "../../../../state/camera/camera.actions";
import {of, switchMap} from "rxjs";
import {worldActions} from "../../../../state/world/world.actions";
import {authActions} from "../../../../state/auth/auth.actions";
import {CanvasState} from "../../../surface/canvas/canvass.state";
import {DRect} from "../../../primitives/drawable-rect";
import {Surface} from "../../../surface/primitives/surface";
import {Assets} from "pixi.js";
import {Vector2} from "three";
import {CanvasService} from "../../../surface/canvas/canvas.service";
import {BinstService} from "../../../binst.service";

export enum PaneType {
  search = 'search',
  profile = 'profile',
  none = 'none'
}

@Component({
  selector: 'multiplex-canvas',
  standalone: true,
  imports: [HeaderBarComponent, BontrollerComponent, RouterOutlet, NgClass, ContextMenuComponent],
  templateUrl: './multiplex-canvas.component.html',
  styleUrl: './multiplex-canvas.component.scss'
})
export class MultiplexCanvasComponent implements AfterViewInit {
  @ViewChild('container') containerRef!: ElementRef;
  protected readonly PaneType = PaneType;

  constructor(
      private canvasService: CanvasService,
      private surfaceService: SurfaceService,
      private store: Store,
      private router: Router,
      private route: ActivatedRoute,
      private binstService: BinstService,
  ) {
    this.store.select(interfaceSelectors.selectContextMenuIsOpen).subscribe((isOpen) => {
      this.contextMenuOpen = isOpen;
    })
  }

  chatsBarHovered = true;
  chatBarOpen = false;
  contextMenuOpen = false;

  setChatHovered(hovered: boolean) {
    this.chatsBarHovered = hovered || !this.chatBarOpen;
    this.store.dispatch(
        cameraActions.triggeredCanvasResizeAnimation({ durationMs: 1000 }),
    );
  }

  readonly childActive$ = this.router.events.pipe(
      switchMap(() => of(this.route.children.length > 0))
  );

  @ViewChild("canvas")
  private canvasRef: ElementRef;


  debug = false;
  leftPaneActive: boolean = false;
  rightPaneActive: boolean = false;

  private get canvas(): HTMLCanvasElement {
    return this.canvasRef.nativeElement;
  }


  setupSubscriptions() {
    this.router.events.subscribe((event) => {
      this.checkIfPanesActive()
      this.store.dispatch(
          cameraActions.triggeredCanvasResizeAnimation({ durationMs: 500 }),
      );
      // }
    })
  }

  checkIfPanesActive() {
    const leftPaneRoute = this.route.children.find(
        child => child.outlet === 'left-pane'
    );
    const rightPaneRoute = this.route.children.find(
        child => child.outlet === 'right-pane'
    );
    if (!this.leftPaneActive && !!leftPaneRoute) {
      this.chatsBarHovered = true
    }
    this.chatBarOpen = leftPaneRoute?.snapshot?.routeConfig?.path === 'chat-bar';
    if (!this.chatBarOpen) this.setChatHovered(true)
    this.leftPaneActive = !!leftPaneRoute
    this.rightPaneActive = !!rightPaneRoute
  }

  async ngAfterViewInit(): Promise<void> {
    this.binstService.startBinstView()
    this.setupSubscriptions();
    this.canvasService.setDocument(document);
    await this.binstService.setupCanvas(this.canvas);
    await this.binstService.setupSurfaces()
    await this.binstService.startThree()
    await this.binstService.startDebris()
    await this.binstService.setupInputs()
    await this.surfaceService.updateCamera()
    const canvass = CanvasState.canvass.values();
    for (let canv of canvass) {
      canv.classList.add("canvas")
      // canv.classList.add("canvas-container")
      this.containerRef.nativeElement.appendChild(canv);
      // document.body.appendChild(canv)
    }
    await this.surfaceService.updateCamera()
  }


}
